import React, { useState, useEffect } from "react";
import "../styles/DisclaimerPopup.css";

const DISCLAIMER_ACCEPTED_KEY = "disclaimerAgreed";
const DISCLAIMER_LAST_SHOWN_KEY = "disclaimerLastShownAt";
const DISCLAIMER_COOLDOWN_MS = 3 * 60 * 60 * 1000; // 3 hours
const DISCLAIMER_DELAY_MS = 5000; // Popup appears after 5 seconds

const DisclaimerPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Backward compatibility: honor older session-based acceptance.
    if (sessionStorage.getItem(DISCLAIMER_ACCEPTED_KEY) === "true") {
      localStorage.setItem(DISCLAIMER_ACCEPTED_KEY, "true");
      return;
    }

    // If already accepted once, do not show again.
    const agreed = localStorage.getItem(DISCLAIMER_ACCEPTED_KEY);
    if (agreed === "true") return;

    // For users who have not accepted, show at most once every 3 hours.
    const lastShownRaw = localStorage.getItem(DISCLAIMER_LAST_SHOWN_KEY);
    const lastShownAt = lastShownRaw ? Number(lastShownRaw) : 0;
    const now = Date.now();

    if (Number.isFinite(lastShownAt) && now - lastShownAt < DISCLAIMER_COOLDOWN_MS) {
      return;
    }

    const timer = window.setTimeout(() => {
      setIsOpen(true);
      localStorage.setItem(DISCLAIMER_LAST_SHOWN_KEY, String(Date.now()));
    }, DISCLAIMER_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, []);

  const handleAgree = () => {
    setIsOpen(false);
    localStorage.setItem(DISCLAIMER_ACCEPTED_KEY, "true");
    localStorage.removeItem(DISCLAIMER_LAST_SHOWN_KEY);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="disclaimer-overlay geist-font fw-lighter">
      <div className="disclaimer-popup">
        <button className="disclaimer-close" onClick={handleClose}>
          &times;
        </button>
        <div className="disclaimer-content">
          <h2 className="disclaimer-title">DISCLAIMER</h2>

          <div className="disclaimer-body">
            <p>
              <span className="disclaimer-note">Note:</span> This website is in the process of being updated. By accessing this website, the viewer confirms that the information including brochures and marketing collateral's on this website are solely for informational purposes only and the viewer has not relied on this information for making any booking/purchase in any project of the Company. Nothing on this website, constitutes advertising, marketing, booking, selling or an offer for sale, or invitation to purchase a unit in any project by the Company. The Company is not liable for any consequence of any action taken by the viewer relying on such material/information on this website.
            </p>
          </div>

          <div className="disclaimer-contact-box">
            <p className="mb-0">
              Please contact our Sales Team at <strong>info@vessella.in</strong> for the updated sales and marketing information and collateral's.
            </p>
          </div>

          <div className="disclaimer-footer">
            <button className="submit-btn geist-font" onClick={handleAgree}>
              I AGREE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
